import React from 'react';
import { ReactComponent as Points } from '../../assets/points.svg';

export const PointsIcon: React.FC<{ size?: number }> = ({ size }) => (
  <Points style={{ width: size || 24, height: size || 24 }} />
);
